const granteeIsTNSLabel = ({ getMiddleText, granteeIsSpouse }) =>
  granteeIsSpouse ? getMiddleText('BENEFICIAIRE_ID_TNS_LABEL') : 'Tarif TNS ?';

const granteeIsTNSIsDisplayed = ({ getMiddleBoolean }) =>
  getMiddleBoolean('BENEFICIAIRE_ID_TNS_EST_NECESSAIRE') &&
  getMiddleBoolean('BENEFICIAIRE_ID_TNS_EST_DEMANDE_DONNEES_CONTRAT');

export { granteeIsTNSLabel, granteeIsTNSIsDisplayed };
